import { isTokenADA, isToken_CS_And_TN_Valid } from '../../Commons/helpers';
import { Token_Historic_Price, Token_With_Price_And_Date, type CS, type TN } from '../../Commons/types';
import { createQueryURLString, hexToStr, showData } from '../../Commons/utils';
import { PriceHistoricEntity } from '../../Entities/Price.Historic.Entity';
import { fetchWrapper } from '../../lib';
import { BaseFrontEndApiCalls } from './Base/Base.FrontEnd.Api.Calls';

export class PriceHistoricFrontEndApiCalls extends BaseFrontEndApiCalls {
    protected static _Entity = PriceHistoricEntity;

    // #region api

    public static async get_Token_Historic_PriceADAx1e6x1e3_Api(CS: CS, TN_Hex: TN, days: number = 90, forceRefresh: boolean = false): Promise<Token_Historic_Price[]> {
        try {
            //------------------
            if (CS === undefined || TN_Hex === undefined) {
                throw `CS or TN_Hex not defined`;
            }
            const isADA = isTokenADA(CS, TN_Hex);
            if (!isToken_CS_And_TN_Valid(CS, TN_Hex)) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            if (isADA) {
                const priceADAx1e6 = 1_000_000n;
                //----------------------------
                const historic_prices: Token_Historic_Price[] = Array(days).fill({ priceADAx1e6, date: undefined });
                //----------------------------
                console.log(`[${this._Entity.className()}] - get_Token_Historic_PriceADAx1e6x1e3_Api - Token Historic Lenght: ${showData(historic_prices.length)} - response OK`);
                return historic_prices;
            }
            //------------------
            const queryString = createQueryURLString({ CS, TN_Hex, days, forceRefresh });
            //------------------
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/historic-priceADAx1e6-by-Token${queryString}`);
            if (response.status === 200) {
                const data = await response.json();
                //----------------------------
                console.log(`[${this._Entity.className()}] - get_Token_Historic_PriceADAx1e6x1e3_Api - Token Historic Lenght: ${showData(data.prices.length)}`);
                //----------------------------
                const historic_prices: Token_Historic_Price[] = [];
                //----------------------------
                data.prices.forEach((data: Token_With_Price_And_Date) => {
                    if (data.priceADAx1e6 === undefined || data.date === undefined) {
                        throw `priceADAx1e6 or date not defined`;
                    }
                    const token: Token_Historic_Price = { priceADAx1e6: BigInt(data.priceADAx1e6), date: BigInt(data.date) };
                    historic_prices.push(token);
                });
                //----------------------------
                return historic_prices;
                //----------------------------
            } else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - get_Token_Historic_PriceADAx1e6x1e3_Api - CS: ${CS} - TN_Hex: ${hexToStr(TN_Hex)} - Token PriceADAx1e6 not found`);
                return [];
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.className()}] - get_Token_Historic_PriceADAx1e6x1e3_Api - Error: ${error}`);
            throw error;
        }
    }

    public static async get_Token_Change_24_Percent_Api(CS: CS, TN_Hex: TN, priceTodayADAx1e6?: bigint, forceRefresh: boolean = false): Promise<number | undefined> {
        try {
            //------------------
            if (CS === undefined || TN_Hex === undefined) {
                throw `CS or TN_Hex not defined`;
            }
            const isADA = isTokenADA(CS, TN_Hex);
            if (!isToken_CS_And_TN_Valid(CS, TN_Hex)) {
                throw `CS or TN_Hex not valid`;
            }
            //------------------
            if (isADA) {
                const change24 = 0;
                console.log(`[${this._Entity.className()}] - get_Token_Change_24_Percent_Api - change24: ${showData(change24)} - response OK`);
                return change24;
            }
            //------------------
            const queryString = createQueryURLString({ CS, TN_Hex, priceToday: priceTodayADAx1e6, forceRefresh });
            //------------------
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/change-24${queryString}`);
            if (response.status === 200) {
                const data = await response.json();
                //----------------------------
                console.log(`[${this._Entity.className()}] - get_Token_Change_24_Percent_Api - change24: ${showData(data)}`);
                //----------------------------
                const change24 = data.change24;
                //----------------------------
                return change24;
                //----------------------------
            } else if (response.status === 404) {
                console.log(`[${this._Entity.className()}] - get_Token_Change_24_Percent_Api - CS: ${CS} - TN_Hex: ${hexToStr(TN_Hex)} - change24 not found`);
                return undefined;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.className()}] - get_Token_Change_24_Percent_Api - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api
}
